class Str {
    public str: string = "";

    constructor(str: string = "") {
        this.str = str;
    }

    static of(str: string) {
        return new Str(str);
    }

    get value() {
        return this.str;
    }

    get nullableBoolean() {
        if (this.str === "false") {
            return false;
        }

        if (this.str === "") {
            return null;
        }

        return true;
    }

    toString() {
        return this.str;
    }

    truncate(length: number = 100, ellipsis: string = "...") {
        this.str = !!this.str && this.str.length > length ? this.str.slice(0, length) + ellipsis : this.str;
        return this;
    }

    capitalise() {
        if (this.str && String(this.str) === this.str) {
            this.str = this.str
                .replace(/_/g, " ")
                .replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
        }
        return this;
    }

    nl2br(is_xhtml = false) {
        var breakTag = is_xhtml || typeof is_xhtml === "undefined" ? "<br />" : "<br>";

        this.str = (this.str + "").replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1" + breakTag + "$2");
        return this;
    }

    nl2p() {
        this.str = "<p>" + this.str.replace(/(\r\n|\r|\n)/, "</p><p>") + "</p>";
        return this;
    }

    stripTags() {
        let doc = new DOMParser().parseFromString(this.str, "text/html");
        this.str = doc.body.textContent || "";
        return this;
    }

    urlify() {
        //TODO ignore urls that are already in a tags
        let urlRegex = new RegExp(
            /(http|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])/g,
        );
        this.str = this.str.replace(urlRegex, (url: string): string => {
            return `<a href="${url}" target="_blank">${url}</a>`;
        });
        return this;
        // or alternatively
        // return text.replace(urlRegex, '<a href="$1">$1</a>')
    }

    //TODO move this to helpers, it's not a string function really
    numberFormat(n: number, decimals: number = 2) {
        return (+n / 100).toFixed(decimals);
    }

    slug() {
        this.str = this.str
            .toLowerCase()
            .replace(/ -/g, "_")
            .replace(/[^\w-]+/g, "");
        return this;
    }

    title() {
        this.str = this.str
            .replace(/[\-_]/g, " ")
            .replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase());
        return this;
    }

    toBool() {
        if (this.str === "true" || this.str === true) {
            return true;
        }
        return !(this.str === "false" || !this.str);
    }

    chunkString(maxWidth) {
        const sections = [];
        const words = this.str.split(" ");
        let builder = "";

        for (const word of words) {
            if (word.length > maxWidth) {
                sections.push(builder.trim());
                builder = "";
                sections.push(word.trim());
                continue;
            }

            let temp = `${builder} ${word}`;
            if (temp.length > maxWidth) {
                sections.push(builder.trim());
                builder = word;
                continue;
            }

            builder = temp;
        }
        sections.push(builder.trim());

        this.str = sections;

        return this;
    }
}

export default Str;
